"use strict";
exports.previousDay = previousDay;
var _index = require("./getDay.js");
var _index2 = require("./subDays.js");
function previousDay(date, day) {
  let delta = (0, _index.getDay)(date) - day;
  if (delta <= 0) delta += 7;
  return (0, _index2.subDays)(date, delta);
}
